/* ==========================================================================
   Limavia · Camiseta de compresión — Landing behaviour (prefix: lcs-)
   Robust, event-delegated. Loaded from the main product section (always on
   the page) so nothing depends on an optional/hideable section.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    root.querySelectorAll('.lcs-gallery').forEach(function (g) {
      if (g.dataset.lcsInit === '1') return;
      g.dataset.lcsInit = '1';
      var slides = Array.prototype.slice.call(g.querySelectorAll('.lcs-gallery__slide'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.lcs-gallery__thumb'));
      if (slides.length <= 1) {
        g.querySelectorAll('.lcs-gallery__arrow').forEach(function (a) { a.style.display = 'none'; });
      }
      var idx = 0;
      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      }
      g.querySelectorAll('.lcs-gallery__arrow--prev').forEach(function (b) {
        b.addEventListener('click', function () { show(idx - 1); });
      });
      g.querySelectorAll('.lcs-gallery__arrow--next').forEach(function (b) {
        b.addEventListener('click', function () { show(idx + 1); });
      });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      // swipe
      var x0 = null;
      var stage = g.querySelector('.lcs-gallery__stage');
      if (stage) {
        stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) { show(idx + (dx < 0 ? 1 : -1)); }
          x0 = null;
        }, { passive: true });
      }
      show(0);
    });
  }

  /* ---------------- Countdown (evergreen) ---------------- */
  function initCountdown(root) {
    root.querySelectorAll('[data-lcs-countdown]').forEach(function (el) {
      if (el.dataset.lcsInit === '1') return;
      el.dataset.lcsInit = '1';
      var mins = parseInt(el.getAttribute('data-lcs-minutes'), 10) || 222; // default ~3h42m
      var durMs = mins * 60 * 1000;
      var key = 'lcs_cd_' + (el.getAttribute('data-lcs-key') || 'default');
      var end = 0;
      try { end = parseInt(window.localStorage.getItem(key), 10) || 0; } catch (e) {}
      var now = Date.now();
      if (!end || end < now) { end = now + durMs; try { window.localStorage.setItem(key, String(end)); } catch (e) {} }
      var out = el.querySelector('[data-lcs-countdown-time]') || el;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        if (diff === 0) { end = Date.now() + durMs; try { window.localStorage.setItem(key, String(end)); } catch (e) {} diff = durMs; }
        out.textContent = pad(Math.floor(diff / 3600000)) + ':' + pad(Math.floor(diff % 3600000 / 60000)) + ':' + pad(Math.floor(diff % 60000 / 1000));
      }
      tick();
      if (el._lcsTimer) clearInterval(el._lcsTimer);
      el._lcsTimer = setInterval(tick, 1000);
    });
  }

  /* ---------------- Videos: buffer with the page ---------------- */
  function initVideos(root) {
    root.querySelectorAll('.lcs-video__frame video').forEach(function (v) {
      try {
        v.muted = true; v.defaultMuted = true; v.loop = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', ''); v.playsInline = true;
        v.autoplay = true; v.preload = 'auto';
        v.load();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } catch (e) {}
    });
  }

  /* ---------------- Sticky mobile bar ---------------- */
  function initSticky(root) {
    var bar = document.querySelector('[data-lcs-sticky]');
    if (!bar || bar.dataset.lcsInit === '1') return;
    bar.dataset.lcsInit = '1';
    var buyAnchor = document.getElementById('lcs-buybox');
    var priceSrc = document.querySelector('[data-lcs-price-mirror]');
    var priceOut = bar.querySelector('[data-lcs-sticky-price]');

    // mirror price text
    function sync() {
      if (priceSrc && priceOut) {
        var t = (priceSrc.textContent || '').replace(/\s+/g, ' ').trim();
        if (t) priceOut.textContent = t;
      }
    }
    if (priceSrc && priceOut) {
      sync();
      try {
        var mo = new MutationObserver(sync);
        mo.observe(priceSrc, { childList: true, subtree: true, characterData: true });
      } catch (e) {}
    }

    // scroll to buy area (never adds to cart)
    var btn = bar.querySelector('[data-lcs-sticky-btn]');
    if (btn) btn.addEventListener('click', function () {
      if (buyAnchor) buyAnchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    var footer = document.querySelector('footer, .footer, [data-lcs-footer]');
    function onScroll() {
      var buyBox = buyAnchor ? buyAnchor.getBoundingClientRect() : null;
      var pastHero = buyBox ? (buyBox.bottom < 0) : (window.scrollY > window.innerHeight * 0.5);
      var footerIn = footer ? (footer.getBoundingClientRect().top < window.innerHeight - 20) : false;
      bar.classList.toggle('is-visible', pastHero && !footerIn);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------------- Delegated toggles (accordions / faqs / modal) ---------------- */
  function initDelegation() {
    if (document.documentElement.dataset.lcsDelegated === '1') return;
    document.documentElement.dataset.lcsDelegated = '1';

    document.addEventListener('click', function (e) {
      var t = e.target;

      // accordion
      var accBtn = t.closest && t.closest('.lcs-acc__btn');
      if (accBtn) {
        var acc = accBtn.closest('.lcs-acc');
        if (acc) {
          var open = acc.classList.toggle('is-open');
          var sign = accBtn.querySelector('.lcs-acc__sign');
          if (sign) sign.textContent = open ? '−' : '+';
        }
        return;
      }

      // mini faq
      var mq = t.closest && t.closest('.lcs-minifaq__q');
      if (mq) {
        var item = mq.closest('.lcs-minifaq__item');
        if (item) {
          var o = item.classList.toggle('is-open');
          var s = mq.querySelector('[data-sign]');
          if (s) s.textContent = o ? '−' : '+';
        }
        return;
      }
      // mini faq "ver mas"
      var more = t.closest && t.closest('.lcs-minifaq__more');
      if (more) {
        var box = more.closest('.lcs-minifaq');
        if (box) {
          var exp = box.classList.toggle('is-expanded');
          more.textContent = exp ? (more.getAttribute('data-less') || 'Ver menos') : (more.getAttribute('data-more') || 'Ver más');
        }
        return;
      }

      // full faq
      var fq = t.closest && t.closest('.lcs-faq__q');
      if (fq) {
        var fitem = fq.closest('.lcs-faq__item');
        if (fitem) {
          var fo = fitem.classList.toggle('is-open');
          var fs = fq.querySelector('span');
          if (fs) fs.textContent = fo ? '−' : '+';
        }
        return;
      }

      // size guide open
      var sg = t.closest && t.closest('[data-lcs-sizeguide-open]');
      if (sg) {
        var m = document.querySelector('[data-lcs-sizeguide]');
        if (m) m.classList.add('is-open');
        return;
      }
      // size guide close (button or overlay)
      if (t.closest && t.closest('[data-lcs-sizeguide-close]')) {
        var mo2 = document.querySelector('[data-lcs-sizeguide]');
        if (mo2) mo2.classList.remove('is-open');
        return;
      }
      var overlay = t.matches && t.matches('[data-lcs-sizeguide]');
      if (overlay) { t.classList.remove('is-open'); return; }

      // secondary CTA → scroll to buy box
      var cta = t.closest && t.closest('[data-lcs-scroll-buy]');
      if (cta) {
        var anchor = document.getElementById('lcs-buybox');
        if (anchor) { e.preventDefault(); anchor.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var m = document.querySelector('[data-lcs-sizeguide].is-open');
        if (m) m.classList.remove('is-open');
      }
    });
  }

  function initAll(root) {
    root = root || document;
    initGallery(root);
    initCountdown(root);
    initVideos(root);
    initSticky(root);
    initDelegation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-init a reloaded section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function () { initAll(document); });
})();
